import {AdsRenderingStatus} from 'common/src/modules/externalAds/externalAds.types';
import {AdsGeneration, AdsTableModalAction, AdsTabState} from './adsTab.types';

const ADS_GENERATION_INITIAL_VALUES: AdsGeneration = {
  inProgress: false,
  status: null,
  issues: [],
  changes: {
    creativesIds: [],
    feedsIds: [],
    adGroupsIds: [],
    cardsIds: [],
  },
};

const ADS_RENDERING_STATUS_INITIAL_VALUES: AdsRenderingStatus = {
  published: 0,
  failed: 0,
  pending: 0,
  planned: 0,
  plannedForUpdate: 0,
  plannedForDeletion: 0,
  syncingWithPlatform: 0,
  pendingSync: 0,
  failedGenerate: 0,
  removedFromPlatform: 0,
};

const ADS_TAB_INITIAL_STATE: AdsTabState = {
  _loading: false,
  ads: [],
  adsRenderingStatus: ADS_RENDERING_STATUS_INITIAL_VALUES,
  adsStatusInfo: {},
  prevVersionAdCount: 0,
  adsStatusInfoLoading: false,
  adsGeneration: ADS_GENERATION_INITIAL_VALUES,
  mediaRenderingStatus: {},
  adsLastUpdateTime: null,
  modalAction: AdsTableModalAction.None,
  showAdsWithIssuesFilter: false,
  selectedRowIds: [],
  dv360CampaignSyncing: false,
  dv360CVSdownloadInProgress: false,
  isPublishAndActivateModalOpen: false,
  mediaRenderingStatuses: [],
  areAdsUpdated: false,
  canBeSkippedToPublish: false,
};

const ADS_TAB_SLICE_NAME = 'adsTab';

export {ADS_TAB_INITIAL_STATE, ADS_GENERATION_INITIAL_VALUES, ADS_TAB_SLICE_NAME};
